import { writable } from 'svelte/store';
import { UserInfo } from '../models/userInfo.model';
export const UserInfos = writable(new UserInfo());
